"use client";

import { useEffect, useState } from "react";
import type { Decision } from "./ExperimentsProvider";
import { useExperimentsContext } from "./ExperimentsProvider";

type Attrs = { countryCode?: string | null; [k: string]: unknown };

export function useExperiment<
  V extends Record<string, unknown> = Record<string, unknown>
>(flag: string, experimentKey: string, attrs?: Attrs) {
  const { decide } = useExperimentsContext();
  const [state, setState] = useState<Decision<V> & { loading?: boolean }>({
    enabled: false,
    variation: null,
    variables: {} as V,
    loading: true
  });

  useEffect(() => {
    let on = true;

    decide<V>(flag, experimentKey, attrs)
      .then((d) => {
        if (on) setState({ ...d, loading: false });
      })
      .catch(() => {
        if (on) setState((prev) => ({ ...prev, loading: false }));
      });

    return () => {
      on = false;
    };
  }, [decide, flag, experimentKey, attrs]);

  return state;
}
